// extracted by mini-css-extract-plugin
module.exports = {"datatable":"DataTable_datatable__1i7eP"};